import styled from "styled-components"
import homeBgImg from 'assets/images/bg_1920.jpg'
import { ReactComponent as LogoSvg } from 'assets/svgs/logo.svg'
import StyledContainer, { RowCenter } from "style/styledContainer"
import SlideCardCom from "components/SlideCardCom"
import IcnWebCardCom from "components/IcnWebCardCom"
import ContactUsCom from "components/ContactUsCom"
import { motion } from "framer-motion"
import { useSystemInfo } from "hooks/useSystemProvider"
import { useEffect, useState } from "react"
import ParticleCom from "components/ParticleCom"

const icnWebDataRoad = [
  { 
    index: 0,
    title: '2.0 Web Application',
    rightText: 'Dec 30',
    year: '2023'
  },
  { 
    index: 1,
    title: 'New Chainge Website',
    rightText: 'Jan 31',
    year: '2024'
  },
  { 
    index: 2,
    title: 'Web App Limit Orders',
    rightText: 'Feb 28',
    year: '2024'
  },
  { 
    index: 3,
    title: '2.0 Mobile Application',
    rightText: 'Mar 31',
    year: '2024'
  }
]

const icnWebDataStats = [
  { 
    index: 0,
    title: 'Cumulative Trading Volume',
    rightText: '$1 Billion',
    year: ''
  },
  { 
    index: 1,
    title: 'Aggregated Liquidity',
    rightText: '$30 Billion',
    year: ''
  },
  { 
    index: 2,
    title: 'EVM & non-EVM chains',
    rightText: '55',
    year: ''
  }
]

const HomePage = () => {
  const { isMobile } = useSystemInfo()
  const [type, setType] = useState('roadmap')
  const [icnWebData, setIcnWebData] = useState(icnWebDataRoad)
  const [curIcnWebIndex, setCurIcnWebIndex] = useState(0)

  useEffect(() => {
    setCurIcnWebIndex(0)
    if(type === 'roadmap') {
      setIcnWebData(icnWebDataRoad)
    } else {
      setIcnWebData(icnWebDataStats)
    }
  }, [type])

  useEffect(() => {
    const timer = setInterval(() => {
      let tempIndex = curIcnWebIndex+1
      if(type === 'roadmap') {
        if(tempIndex > 3) {
          setCurIcnWebIndex(0)
        } else {
          setCurIcnWebIndex(tempIndex)
        }
      } else {
        if(tempIndex > 2) {
          setCurIcnWebIndex(0)
        } else {
          setCurIcnWebIndex(tempIndex)
        }
      }
    }, 1000 * 5)
    return () => {
      clearInterval(timer)
    }
  }, [curIcnWebIndex, type])
  

  return <HomeContainer>
    {/* Particle module */}
    <ParticleCom></ParticleCom>
    <StyledContainer height="50px"></StyledContainer>
    <LogoSvgWrap></LogoSvgWrap>
    <StyledContainer height="100px"></StyledContainer>
    <CenterWrap roobertBold fontSize={ isMobile ? '26px': '30px'}>
      <AnimatedHomeTitle 
        initial={{ transform:  'rotateX(90deg)' }}
        animate={{ transform:  'rotateX(0deg)' }}
        transition={{ duration: 1.5 }}>One marketplace. All crypto.</AnimatedHomeTitle>
    </CenterWrap>
    <StyledContainer height="20px"></StyledContainer>
    <CenterWrap roobertRegular fontSize={ isMobile ? '16px': '18px'} lineHeight={ isMobile ? '22px': '26px'} width={isMobile ? '100%': '500px'} margin="0 auto">
      As we craft Chainge 2.0 to elevate your crypto experience, get ready for the ultimate DeFi journey.
    </CenterWrap>
    <StyledContainer height="50px"></StyledContainer>
    <SwitchBtn>
      <SwitchLabel isActive={type === 'roadmap'} onClick={() => setType('roadmap')}>Roadmap</SwitchLabel>
      <SwitchLabel isActive={type === 'stats'} onClick={() => setType('stats')}>Stats</SwitchLabel>
    </SwitchBtn>
    <StyledContainer height="20px"></StyledContainer>
    <SlideCardCom type={type === 'roadmap' ? '0' : '1'} index={icnWebData[curIcnWebIndex].index} title={icnWebData[curIcnWebIndex].title} rightText={icnWebData[curIcnWebIndex].rightText} year={icnWebData[curIcnWebIndex].year}></SlideCardCom>
    <StyledContainer height="70px"></StyledContainer>
    <RowCenter flexDirection={isMobile ? 'column': 'row'}>
      <RowCenter>
        <IcnWebCardCom type="web"></IcnWebCardCom>
        <StyledContainer width="6px"></StyledContainer>
        <IcnWebCardCom type="appstore"></IcnWebCardCom>
      </RowCenter>
      <StyledContainer width="6px" height="6px"></StyledContainer>
      <IcnWebCardCom type="google"></IcnWebCardCom>
    </RowCenter>
    <StyledContainer height="180px"></StyledContainer>
    <CenterWrap roobertSemiBold fontSize="14px">
      Follow us for live updates:
    </CenterWrap>
    <StyledContainer height="14px"></StyledContainer>
    <ContactUsCom></ContactUsCom>
    <StyledContainer height="70px"></StyledContainer>
  </HomeContainer>
}

const HomeContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${homeBgImg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 700px) {
    padding: 0 15px;
    box-sizing: border-box;
  }
`

const HomeBg = styled.img`
  position: fixed;
  z-index: -1;
  width: 100vw;
`

const LogoSvgWrap = styled(LogoSvg)`
  margin: 0 auto;
  display: block;
  position: relative;
  z-index: 1;
`

const CenterWrap = styled(StyledContainer)`
  text-align: center;
`

const SwitchBtn = styled(StyledContainer)`
  width: 148px;
  height: 36px;
  font-size: 14px;
  line-height: 1;
  background-color: rgba(255, 246, 242, 0.6);
  border-radius: 31px;
  margin: 0 auto;
  padding: 10px 16px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

const SwitchLabel = styled(StyledContainer)<{isActive: boolean}>`
  cursor: pointer;
  &:hover {
    color: #e24de5;
  }
  font-family: ${({isActive}: any) => isActive ? 'RoobertSemiBold' : 'RoobertRegular'};
  color: ${({isActive}: any) => isActive ? '#0a0a0a !important' : '#767a7f'};
`

// 动画
const AnimatedHomeTitle = styled(motion.div)``

export default HomePage